import type { CSSProperties } from 'react';

export type ReportPreviewLayout = 'modal' | 'export';

export const REPORT_PREVIEW_PAGE_WIDTH_MM = 210;
export const REPORT_PREVIEW_PAGE_HEIGHT_MM = 297;
export const REPORT_PREVIEW_PDF_MARGIN_MM = 10;

export const REPORT_PREVIEW_PRINTABLE_HEIGHT_MM =
  REPORT_PREVIEW_PAGE_HEIGHT_MM - REPORT_PREVIEW_PDF_MARGIN_MM * 2;

export function mmToPx(mm: number): number {
  return (mm / 25.4) * 96;
}

export const REPORT_PREVIEW_PRINTABLE_HEIGHT_PX = mmToPx(
  REPORT_PREVIEW_PRINTABLE_HEIGHT_MM,
);

export const reportPreviewPageGradientClassName =
  'tw-bg-gradient-to-b tw-from-[#F8F9FA] tw-to-[#FFF7F9]';

export const reportPreviewPageShellBaseClassName =
  'tw-box-border tw-flex tw-flex-col tw-rounded-lg tw-border tw-border-grayscale-20 tw-bg-white tw-p-4 tw-shadow-sm';

export const reportPreviewPageShellClassName = `${reportPreviewPageShellBaseClassName} tw-w-full tw-max-w-[210mm] tw-min-h-[297mm]`;

export const reportPreviewFitPageShellClassName = `${reportPreviewPageShellBaseClassName} tw-h-full tw-w-full tw-overflow-hidden`;

export const reportPreviewExportPageShellClassName =
  'tw-box-border tw-flex tw-w-full tw-flex-col tw-rounded-lg tw-bg-white tw-p-3';

export const reportPreviewExportCoverClassName = `tw-flex tw-w-full tw-flex-col tw-rounded-lg ${reportPreviewPageGradientClassName}`;

export function getReportPreviewExportPageStyle(
  pageNumber: number,
  totalPages: number,
  breakBeforeFirstPage: boolean,
): CSSProperties {
  const shouldBreakBefore =
    pageNumber > 1 || (pageNumber === 1 && breakBeforeFirstPage);

  return {
    boxSizing: 'border-box',
    minHeight: REPORT_PREVIEW_PRINTABLE_HEIGHT_PX,
    breakInside: 'avoid',
    pageBreakInside: 'avoid',
    breakBefore: shouldBreakBefore ? 'page' : 'auto',
    pageBreakBefore: shouldBreakBefore ? 'always' : 'auto',
    breakAfter: pageNumber < totalPages ? 'page' : 'auto',
    pageBreakAfter: pageNumber < totalPages ? 'always' : 'auto',
  };
}

export function getReportPreviewExportCoverStyle(): CSSProperties {
  return {
    boxSizing: 'border-box',
    minHeight: REPORT_PREVIEW_PRINTABLE_HEIGHT_PX,
    breakInside: 'avoid',
    pageBreakInside: 'avoid',
    breakAfter: 'page',
    pageBreakAfter: 'always',
  };
}

export function getReportPreviewPageShellClassName(
  layout: ReportPreviewLayout = 'modal',
): string {
  return layout === 'export'
    ? reportPreviewExportPageShellClassName
    : reportPreviewPageShellClassName;
}
